<template>
    <div>
        <modal
                :width="500"
                height="auto"
                name="m-createFolder"
                >
            <div class="modal-dialog abtg-modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title abtg__modal-title" v-text="content.meditFolder?$t('mapping.folder_edit_title'):$t('mapping.folder_create_title')" ></h5>



                        <div class="tools">
                            <div class="abtg__close-button"><a @click="closeModal()"><i
                                    class="fas fa-times"></i></a></div>
                        </div>
                    </div>

                        <div class="modal-body">
                          <div class="row">
                            <div class="col-lg-10" ><span v-text="content.meditFolder?$t('mapping.folder_edit_name'):$t('mapping.folder_create_name')"></span>


                              <input type="text" class="mx-2" v-model="content.folderName"></div>
                          </div>

                          <p v-if="error" class="text-danger">{{ $t('mapping.folder_create_error') }}</p>
                        </div>
                        <div class="modal-footer">
                            <button
                                    @click="createFolder()"
                                    type="submit" class="btn btn-default  abtg__btn-third shadow-none"
                                    v-text="content.meditFolder?$t('mapping.folder_edit'):$t('mapping.folder_create')">

                            </button>

                        </div>


                </div>
            </div>
        </modal>
    </div>

</template>
<script>
    export default {
      props: ['content'],
      data() {

        return {
          folderName:'',
          error: false,
        }
      },
      methods: {
            closeModal() {
                this.$emit('closeModal','m-createFolder');
            },

          createFolder()

          {
            this.folderName = this.content.folderName;
            if (this.folderName==""){
            this.error=true;
            }else{
                this.$emit('createFolder',this.folderName);
                this.closeModal();
            }}
        }
    }
</script>